(function () {
  var dataLayerName = 'analyzelyDataLayer';
  var debugLayerName = 'evolovaDataLayer';
  var suppressStorageKey = 'evolova_test_traffic';
  var recentEvents = {};
  var recentExplicitCartAdds = {};
  var lastCart = null;
  var pendingVariantSelection = null;

  function getSearchParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (error) {
      return null;
    }
  }

  function isEnabledValue(value) {
    return /^(1|true|yes|on|internal|developer|test)$/i.test(String(value || ''));
  }

  function isDisabledValue(value) {
    return /^(0|false|no|off|live|production)$/i.test(String(value || ''));
  }

  function setSuppression(reason) {
    if (!reason) return;
    window.EVOLOVA_ANALYTICS_SUPPRESS = true;
    window.EVOLOVA_ANALYTICS_SUPPRESSION_REASON = reason;
    try {
      window.sessionStorage.setItem(suppressStorageKey, reason);
    } catch (error) {}
  }

  function clearSuppression() {
    window.EVOLOVA_ANALYTICS_SUPPRESS = false;
    window.EVOLOVA_ANALYTICS_SUPPRESSION_REASON = '';
    try {
      window.sessionStorage.removeItem(suppressStorageKey);
    } catch (error) {}
  }

	  function getSuppressionReason() {
	    var params = getSearchParams();
	    var explicitTest = params && (params.get('evo_test') || params.get('evolova_test') || params.get('ga_test') || params.get('traffic_type'));
	
	    if (isTestThemePreview()) {
	      setSuppression('test_theme_preview');
	      return 'test_theme_preview';
	    }
	
	    if (explicitTest && isDisabledValue(explicitTest)) {
	      clearSuppression();
	      return '';
    }

    if (explicitTest && isEnabledValue(explicitTest)) {
      setSuppression('explicit_test_parameter');
      return 'explicit_test_parameter';
    }

    if (params && (params.has('preview_theme_id') || params.has('shgpvid'))) {
      setSuppression('theme_preview');
      return 'theme_preview';
    }

    if (window.Shopify && window.Shopify.designMode) {
      setSuppression('shopify_design_mode');
      return 'shopify_design_mode';
    }

    if (window.EVOLOVA_ANALYTICS_SUPPRESS) {
      return window.EVOLOVA_ANALYTICS_SUPPRESSION_REASON || 'global_suppression';
    }

    try {
      return window.sessionStorage.getItem(suppressStorageKey) || '';
    } catch (error) {
      return '';
	    }
	  }

	  function isTestThemePreview() {
	    var theme = window.Shopify && window.Shopify.theme;
	    if (!theme) return false;
	    var themeId = String(theme.id || theme.theme_store_id || '');
	    if (themeId === '188705407269') return true;
	    var themeName = String(theme.name || theme.role || '').toLowerCase();
	    return /测试主题|test|preview|draft|development/.test(themeName);
	  }

  function getCurrency() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.shopCurrency) ||
      'USD'
    );
  }

  function getDeviceCategory() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 750) return 'mobile';
    if (width < 1025) return 'tablet';
    return 'desktop';
  }

  function getPageContext(extra) {
    return Object.assign(
      {
        event_source: 'evolova_theme',
        page_location: window.location.href,
        page_path: window.location.pathname,
        device_category: getDeviceCategory()
      },
      extra || {}
    );
  }

  function sendGtag(eventName, params) {
    var payload = getPageContext(params);
    var suppressionReason = getSuppressionReason();
    window[dataLayerName] = window[dataLayerName] || [];
    window[debugLayerName] = window[debugLayerName] || [];
    window[debugLayerName].push(Object.assign({
      event: eventName,
      timestamp: Date.now(),
      analytics_suppressed: Boolean(suppressionReason),
      suppression_reason: suppressionReason || undefined
    }, payload));

    if (suppressionReason) return;

    if (typeof window.analyzelyGtag === 'function') {
      window.analyzelyGtag('event', eventName, payload);
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    } else {
      window[dataLayerName].push(['event', eventName, payload]);
    }
  }

  function dedupe(key, ttl) {
    var now = Date.now();
    if (recentEvents[key] && now - recentEvents[key] < ttl) return true;
    recentEvents[key] = now;
    return false;
  }

  function centsToAmount(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return 0;
    return number > 1000 ? number / 100 : number;
  }

  function productHandleFromUrl(url) {
    var match = String(url || window.location.pathname).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getDataValue(node, key) {
    var attr = 'data-' + key.replace(/[A-Z]/g, function (letter) {
      return '-' + letter.toLowerCase();
    });
    var current = node instanceof Element ? node : null;

    while (current) {
      if (current.dataset && current.dataset[key]) return current.dataset[key];
      if (current.getAttribute && current.getAttribute(attr)) return current.getAttribute(attr);
      current = current.parentElement;
    }

    return '';
  }

  function findVariant(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getSourceArea(target, form) {
    var node = target || form;
    if (!node) return 'unknown';
    var explicitSourceArea = getDataValue(node, 'sourceArea');
    if (explicitSourceArea) return explicitSourceArea;
    if (node.closest?.('cart-drawer')) return 'cart_drawer';
    if (node.closest?.('.template-cart, .section--main-cart, cart-items-component')) return 'cart_page';
    if (node.closest?.('sticky-atc') || String(node.id || '').indexOf('StickyCart-ProductSubmitButton') === 0) return 'sticky_add_to_cart';
    if (node.closest?.('.main-product-information, product-info, .product-form__buttons')) return 'pdp_main';
    if (node.closest?.('quick-add-modal')) return 'quick_add';
    if (node.closest?.('.evo-collection-card__actions, .card--block-button, .card, .card-product, .product-card, .collection, .template-collection, .template-search')) return 'collection_card';
    return 'unknown';
  }

  function getListName(target, form) {
    var node = target || form;
    return getDataValue(node, 'itemListName') || getSourceArea(node, form);
  }

  function getListId(target, form) {
    var node = target || form;
    return getDataValue(node, 'itemListId') || getDataValue(node, 'sourceArea') || getSourceArea(node, form);
  }

  function getCardPosition(target, form) {
    var position = getDataValue(target || form, 'cardPosition');
    var number = Number(position);
    return Number.isFinite(number) && number > 0 ? number : undefined;
  }

  function getFormForTarget(target) {
    if (!target) return null;
    if (target.closest?.('form')) return target.closest('form');
    if (target.form instanceof HTMLFormElement) return target.form;
    var formId = target.getAttribute?.('form');
    return formId ? document.getElementById(formId) : null;
  }

  function getFormDataValue(form, name) {
    if (!form) return '';
    try {
      return new FormData(form).get(name) || '';
    } catch (e) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.value : '';
    }
  }

  function getQuantity(form, fallback) {
    var quantity = Number(getFormDataValue(form, 'quantity') || fallback || 1);
    return Math.max(1, Number.isFinite(quantity) ? quantity : 1);
  }

  function getProductMeta(form, variantId, lineItem, target) {
    var metaProduct = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var variant = findVariant(metaProduct, variantId || lineItem?.variant_id || lineItem?.id);
    var contextNode = target || form;
    var dataTitle = getDataValue(contextNode, 'productTitle');
    var dataHandle = getDataValue(contextNode, 'productHandle');
    var dataProductId = getDataValue(contextNode, 'productId');
    var dataVariantId = getDataValue(contextNode, 'variantId');
    var title =
      lineItem?.product_title ||
      dataTitle ||
      (contextNode && contextNode.closest?.('[data-product-title]') && contextNode.closest('[data-product-title]').dataset.productTitle) ||
      (metaProduct && metaProduct.title) ||
      document.querySelector('[data-product-title]')?.textContent ||
      document.querySelector('h1')?.textContent ||
      document.title;
    var productHandle = lineItem?.handle || dataHandle || productHandleFromUrl();
    var normalizedVariantId = String(variantId || dataVariantId || lineItem?.variant_id || lineItem?.id || (variant && variant.id) || '');

    return {
      item_id: normalizedVariantId,
      item_name: String(title || '').trim(),
      item_brand: String(lineItem?.vendor || (metaProduct && metaProduct.vendor) || 'Evolova'),
      item_variant: String(lineItem?.variant_title || (variant && (variant.public_title || variant.name || variant.title)) || ''),
      item_category: String(lineItem?.product_type || (metaProduct && metaProduct.type) || 'product'),
      price: centsToAmount(lineItem?.price || (variant && variant.price)),
      product_handle: productHandle,
      product_id: String(lineItem?.product_id || dataProductId || (metaProduct && metaProduct.id) || ''),
      variant_id: normalizedVariantId
    };
  }

  function buildItem(item, quantity, extra) {
    return Object.assign({
      item_id: item.item_id,
      item_name: item.item_name,
      item_brand: item.item_brand,
      item_variant: item.item_variant,
      item_category: item.item_category,
      price: item.price || undefined,
      quantity: quantity
    }, extra || {});
  }

  function buildProductPayload(item, quantity, extra) {
    var itemExtra = {};
    if (extra?.item_list_name) itemExtra.item_list_name = extra.item_list_name;
    if (extra?.item_list_id) itemExtra.item_list_id = extra.item_list_id;
    if (extra?.index) itemExtra.index = extra.index;
    var value = item.price ? item.price * quantity : undefined;
    return Object.assign(
      {
        currency: getCurrency(),
        value: value,
        product_handle: item.product_handle,
        product_id: item.product_id,
        variant_id: item.variant_id,
        items: [buildItem(item, quantity, itemExtra)]
      },
      extra || {}
    );
  }

  function normalizeTrackedItems(items, extra) {
    if (!Array.isArray(items)) return [];
    return items
      .map(function (item, index) {
        var quantity = Math.max(1, Number(item.quantity || 1) || 1);
        return {
          item_id: String(item.item_id || item.variant_id || item.id || ''),
          item_name: String(item.item_name || item.product_title || item.title || 'Bundle item'),
          item_brand: String(item.item_brand || item.vendor || 'Evolova'),
          item_variant: String(item.item_variant || item.variant_title || ''),
          item_category: String(item.item_category || item.product_type || 'product'),
          price: centsToAmount(item.price),
          quantity: quantity,
          item_list_name: item.item_list_name || extra?.item_list_name,
          item_list_id: item.item_list_id || extra?.item_list_id,
          index: item.index || index + 1
        };
      })
      .filter(function (item) {
        return item.item_id;
      });
  }

  function buildMultiItemPayload(items, extra) {
    var normalizedItems = normalizeTrackedItems(items, extra);
    var value = normalizedItems.reduce(function (sum, item) {
      return sum + (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }, 0);

    return Object.assign(
      {
        currency: getCurrency(),
        value: value || undefined,
        items: normalizedItems,
        bundle_item_count: normalizedItems.length
      },
      extra || {}
    );
  }

	  function rememberExplicitCartAdd(variantId, sourceArea, actionId) {
	    var now = Date.now();
	    if (variantId) recentExplicitCartAdds['variant:' + variantId + ':' + sourceArea] = now;
	    if (actionId) recentExplicitCartAdds['action:' + actionId] = now;
	  }

	  function getAttemptId(detail) {
	    return detail?.attemptId || detail?.attempt_id || detail?.actionId || '';
	  }

	  function getFormAttemptId(form) {
	    return (form && form.dataset && form.dataset.evoCartAttemptId) || '';
	  }

	  function isManagedProductForm(form) {
	    return !!(form && form.closest && form.closest('product-form-component'));
	  }

  function hasRecentExplicitCartAdd(variantId, sourceArea, actionId) {
    var now = Date.now();
    var variantKey = variantId ? 'variant:' + variantId + ':' + sourceArea : '';
    var actionKey = actionId ? 'action:' + actionId : '';
    return (
      (variantKey && recentExplicitCartAdds[variantKey] && now - recentExplicitCartAdds[variantKey] < 6000) ||
      (actionKey && recentExplicitCartAdds[actionKey] && now - recentExplicitCartAdds[actionKey] < 6000)
    );
  }

  function buildCartPayload(cart, extra) {
    var items = Array.isArray(cart?.items)
      ? cart.items.map(function (line) {
              return buildItem(getProductMeta(null, line.variant_id || line.id, line), line.quantity || 1);
        })
      : [];

    return Object.assign(
      {
        currency: getCurrency(),
        value: centsToAmount(cart?.total_price),
        cart_item_count: cart?.item_count || 0,
        cart_token: cart?.token || undefined,
        items: items
      },
      extra || {}
    );
  }

  function fetchCart() {
    var rootUrl = window.routes?.root_url || '/';
    var cartUrl = rootUrl.replace(/\/?$/, '/') + 'cart.js';
    return fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) lastCart = cart;
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

	  function trackAddToCartClick(form, target, source, detail) {
	    var sourceArea = detail?.sourceArea || getSourceArea(target, form);
	    var variantId = getFormDataValue(form, 'id');
	    var quantity = getQuantity(form);
	    var attemptId = getAttemptId(detail) || getFormAttemptId(form);
	    var trackedItems = normalizeTrackedItems(detail?.items, {
	      item_list_name: detail?.itemListName || getListName(target, form),
	      item_list_id: detail?.itemListId || getListId(target, form)
    });
    var item = getProductMeta(form, detail?.variantId || variantId || trackedItems[0]?.item_id, null, target);
    var shouldCheckDisabled = source === 'pointerdown' || source === 'submit';
    var disabled = shouldCheckDisabled && (target?.matches?.('[disabled], [aria-disabled="true"]') || target?.closest?.('[disabled], [aria-disabled="true"]'));
    var listName = detail?.itemListName || getListName(target, form);
    var listId = detail?.itemListId || getListId(target, form);
    var position = getCardPosition(target, form);

    if (trackedItems.length) {
      var bundleClickKey = 'atc-click:items:' + trackedItems.map(function (trackedItem) {
        return trackedItem.item_id + 'x' + trackedItem.quantity;
      }).join('|') + ':' + sourceArea;
      if (dedupe(bundleClickKey, 1500)) return;
      sendGtag(
        'add_to_cart_click',
        buildMultiItemPayload(trackedItems, {
	          source_area: sourceArea,
	          item_list_name: listName,
	          item_list_id: listId,
	          submit_source: source || 'unknown',
	          action_id: attemptId || undefined,
	          attempt_id: attemptId || undefined,
	          bundle_tracking: true
	        })
	      );
      return;
    }

    if (!form || !/\/cart\/add/.test(form.action || '')) {
      sendGtag('add_to_cart_error', {
          error_reason: 'missing_cart_add_form',
	          source_area: sourceArea,
	          item_list_name: listName,
	          item_list_id: listId,
	          index: position,
	          submit_source: source || 'unknown',
	          action_id: attemptId || undefined,
	          attempt_id: attemptId || undefined
	        });
	      return;
	    }

    if (disabled) {
      var disabledKey = 'atc-disabled:' + variantId + ':' + sourceArea;
      if (dedupe(disabledKey, 1500)) return;
      sendGtag(
        'add_to_cart_error',
        buildProductPayload(item, quantity, {
          error_reason: 'disabled_button',
	          source_area: sourceArea,
	          item_list_name: listName,
	          item_list_id: listId,
	          index: position,
	          submit_source: source || 'unknown',
	          action_id: attemptId || undefined,
	          attempt_id: attemptId || undefined
	        })
	      );
      return;
    }

    if (!variantId) {
      sendGtag(
        'add_to_cart_error',
        buildProductPayload(item, quantity, {
          error_reason: 'missing_variant_id',
	          source_area: sourceArea,
	          item_list_name: listName,
	          item_list_id: listId,
	          index: position,
	          submit_source: source || 'unknown',
	          action_id: attemptId || undefined,
	          attempt_id: attemptId || undefined
	        })
	      );
      return;
    }

    var key = 'atc-click:' + variantId + ':' + quantity + ':' + sourceArea;
    if (dedupe(key, 1500)) return;

    sendGtag(
      'add_to_cart_click',
      buildProductPayload(item, quantity, {
	        source_area: sourceArea,
	        item_list_name: listName,
	        item_list_id: listId,
	        index: position,
	        submit_source: source || 'unknown',
	        action_id: attemptId || undefined,
	        attempt_id: attemptId || undefined
	      })
	    );
	  }

  function trackAddToCartSuccess(detail) {
    var form = detail?.form || null;
    var response = detail?.response || null;
    var variantId = detail?.variantId || response?.variant_id || response?.id || getFormDataValue(form, 'id');
    var quantity = Number(detail?.quantity || response?.quantity || getQuantity(form));
    var trackedItems = normalizeTrackedItems(detail?.items, {
      item_list_name: detail?.itemListName || getListName(detail?.target || null, form),
      item_list_id: detail?.itemListId || getListId(detail?.target || null, form)
    });
    var item = getProductMeta(form, variantId, response, detail?.target || null);
    var sourceArea = detail?.sourceArea || getSourceArea(null, form);
    var listName = getListName(detail?.target || null, form);
    var listId = getListId(detail?.target || null, form);
    var position = getCardPosition(detail?.target || null, form);

    if (trackedItems.length) {
      var multiKey = 'atc-success:items:' + trackedItems.map(function (trackedItem) {
        return trackedItem.item_id + 'x' + trackedItem.quantity;
      }).join('|') + ':' + sourceArea;
      if (dedupe(multiKey, 4000)) return;
	      var multiPayload = buildMultiItemPayload(trackedItems, {
	        source_area: sourceArea,
	        item_list_name: listName,
	        item_list_id: listId,
	        cart_action_source: detail?.source || 'cart_add',
	        action_id: detail?.actionId,
	        attempt_id: getAttemptId(detail) || undefined,
	        bundle_tracking: true
	      });
      sendGtag('add_to_cart_success', multiPayload);
      sendGtag('add_to_cart', multiPayload);
      rememberExplicitCartAdd(variantId || trackedItems[0]?.item_id, sourceArea, detail?.actionId);
      fetchCart();
      return;
    }

    var key = 'atc-success:' + variantId + ':' + quantity + ':' + sourceArea;
    if (dedupe(key, 4000)) return;

	    var payload = buildProductPayload(item, quantity, {
	      source_area: sourceArea,
	      item_list_name: listName,
	      item_list_id: listId,
	      index: position,
	      cart_line_key: response?.key,
	      cart_action_source: detail?.source || 'cart_add',
	      action_id: detail?.actionId,
	      attempt_id: getAttemptId(detail) || undefined
	    });

    sendGtag('add_to_cart_success', payload);
    sendGtag('add_to_cart', payload);
    rememberExplicitCartAdd(variantId, sourceArea, detail?.actionId);
    fetchCart();
  }

  function trackAddToCartError(detail) {
    var form = detail?.form || null;
    var response = detail?.response || null;
    var variantId = detail?.variantId || response?.variant_id || response?.id || getFormDataValue(form, 'id');
    var quantity = Number(detail?.quantity || getQuantity(form));
    var item = getProductMeta(form, variantId, response, detail?.target || null);
    var sourceArea = detail?.sourceArea || getSourceArea(null, form);
    var listName = getListName(detail?.target || null, form);
    var listId = getListId(detail?.target || null, form);
    var position = getCardPosition(detail?.target || null, form);
    var reason = detail?.reason || response?.message || response?.description || 'cart_add_error';
    var key = 'atc-error:' + variantId + ':' + reason + ':' + sourceArea;
    if (dedupe(key, 1500)) return;

    sendGtag(
      'add_to_cart_error',
      buildProductPayload(item, quantity, {
        source_area: sourceArea,
        item_list_name: listName,
	        item_list_id: listId,
	        index: position,
	        error_reason: String(reason),
	        error_message: String(detail?.message || response?.description || response?.message || ''),
	        action_id: detail?.actionId || undefined,
	        attempt_id: getAttemptId(detail) || undefined,
	        repeated_click: detail?.repeatedClick || undefined
	      })
	    );
	  }

  function trackCartDrawerOpen(detail) {
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      var key = 'cart-drawer-open:' + (cart.token || cart.item_count + ':' + cart.total_price);
      if (dedupe(key, 5000)) return;
      var payload = buildCartPayload(cart, {
        source_area: getSourceArea(detail?.triggeredBy || null, null)
      });
      sendGtag('cart_drawer_open', payload);
      sendGtag('view_cart', payload);
    });
  }

  function trackCheckoutHandoff(detail) {
    var sourceArea = detail?.sourceArea || getSourceArea(detail?.target || null, null);
    var response = detail?.response || null;

    if (response && (response.variant_id || response.id)) {
      var variantId = detail?.variantId || response.variant_id || response.id;
      var quantity = Number(detail?.quantity || response.quantity || 1);
      var item = getProductMeta(detail?.form || null, variantId, response);
      var productPayload = buildProductPayload(item, quantity, {
        source_area: sourceArea,
        handoff_source: detail?.source || 'buy_now'
      });
      var productKey = 'checkout-handoff-product:' + variantId + ':' + sourceArea;
      if (!dedupe(productKey, 5000)) {
        sendGtag('checkout_handoff', productPayload);
        sendGtag('begin_checkout', productPayload);
      }
      return;
    }

    var cart = lastCart;
    if (!cart || !cart.item_count) {
      fetchCart().then(function (freshCart) {
        if (freshCart && freshCart.item_count) trackCheckoutHandoff(Object.assign({}, detail, { cart: freshCart }));
      });
      return;
    }

    var key = 'checkout-handoff-cart:' + (cart.token || cart.item_count + ':' + cart.total_price) + ':' + sourceArea;
    if (dedupe(key, 5000)) return;
    var payload = buildCartPayload(cart, {
      source_area: sourceArea,
      handoff_source: detail?.source || 'cart_checkout'
    });
    sendGtag('checkout_handoff', payload);
    sendGtag('begin_checkout', payload);
  }

	  function trackVariantSelectFromPending(variant) {
	    if (!pendingVariantSelection) return;
	    var pending = pendingVariantSelection;
    pendingVariantSelection = null;
    var variantId = variant?.id || '';
    var key = 'variant-select:' + pending.optionName + ':' + pending.optionValue + ':' + variantId;
    if (dedupe(key, 1000)) return;

    sendGtag('variant_select', {
      product_handle: productHandleFromUrl(),
      variant_id: String(variantId),
      option_name: pending.optionName,
      option_value: pending.optionValue,
      selected_options: Array.isArray(variant?.options) ? variant.options.join(' / ') : undefined,
      variant_available: variant?.available,
      price: centsToAmount(variant?.price),
      source_area: pending.sourceArea
	    });
	  }

	  var contentEngagementState = {
	    initialized: false,
	    startedAt: Date.now(),
	    maxScrollDepth: 0,
	    depthCheckpoints: {},
	    viewedById: {},
	    viewedList: [],
	    exitSent: false,
	    scrollTicking: false,
	    observer: null,
	    maxSectionViews: 16
	  };

	  function truncateParam(value, limit) {
	    var text = String(value || '').replace(/\s+/g, ' ').trim();
	    if (!text) return '';
	    return text.length > limit ? text.slice(0, limit - 1).trim() + '…' : text;
	  }

	  function slugifyParam(value, fallback) {
	    var slug = String(value || '')
	      .toLowerCase()
	      .replace(/[^a-z0-9]+/g, '_')
	      .replace(/^_+|_+$/g, '')
	      .slice(0, 64);
	    return slug || fallback || 'section';
	  }

	  function getLanguageCode() {
	    return (
	      (window.Shopify && window.Shopify.locale) ||
	      document.documentElement.getAttribute('lang') ||
	      (window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/) || [])[1] ||
	      'en'
	    );
	  }

	  function getPageTemplate() {
	    var bodyClass = document.body ? document.body.className || '' : '';
	    var templateClass = String(bodyClass).split(/\s+/).find(function (className) {
	      return className.indexOf('template-') === 0;
	    });
	    if (templateClass) return templateClass.replace(/^template-/, '') || 'page';
	    if (/\/products\//.test(window.location.pathname)) return 'product';
	    if (/\/collections\//.test(window.location.pathname)) return 'collection';
	    if (/\/cart/.test(window.location.pathname)) return 'cart';
	    if (/\/pages\//.test(window.location.pathname)) return 'page';
	    if (window.location.pathname === '/' || /^\/[a-z]{2}\/?$/.test(window.location.pathname)) return 'index';
	    return 'page';
	  }

	  function getContentType(element) {
	    if (!element) return getPageTemplate();
	    var pageTemplate = getPageTemplate();
	    var path = window.location.pathname;
	    var className = element.className ? String(element.className) : '';
	    if (pageTemplate === 'product' || /\/products\//.test(path)) return 'pdp';
	    if (pageTemplate === 'collection' || /\/collections\//.test(path)) return 'collection';
	    if (pageTemplate === 'cart' || /\/cart/.test(path)) return 'cart';
	    if (pageTemplate === 'index') {
	      if (/products|product-grid|pick|card-grid/.test(className)) return 'home_product_grid';
	      if (/hero/.test(className)) return 'hero';
	      if (/review/.test(className)) return 'reviews';
	      if (/compare|comparison/.test(className)) return 'comparison';
	      if (/tech|science|feature/.test(className)) return 'education';
	      return 'home';
	    }
	    if (/hero/.test(className)) return 'hero';
	    if (/review/.test(className)) return 'reviews';
	    if (/compare|comparison/.test(className)) return 'comparison';
	    if (/tech|science|feature/.test(className)) return 'education';
	    if (/article|page|guide|faq/.test(className) || /\/pages\//.test(path)) return 'page';
	    return pageTemplate;
	  }

	  function getScrollDepth() {
	    var doc = document.documentElement;
	    var body = document.body;
	    var scrollHeight = Math.max(
	      doc ? doc.scrollHeight : 0,
	      body ? body.scrollHeight : 0,
	      doc ? doc.offsetHeight : 0,
	      body ? body.offsetHeight : 0
	    );
	    var viewportHeight = window.innerHeight || (doc && doc.clientHeight) || 0;
	    if (!scrollHeight || scrollHeight <= viewportHeight) return 100;
	    var viewedBottom = (window.pageYOffset || doc.scrollTop || body.scrollTop || 0) + viewportHeight;
	    return Math.max(0, Math.min(100, Math.round((viewedBottom / scrollHeight) * 100)));
	  }

	  function getStableClassName(element) {
	    if (!element || !element.classList) return '';
	    var classes = Array.prototype.slice.call(element.classList);
	    return (
	      classes.find(function (className) {
	        return /^(evolova|evo)-[a-z0-9-]+$/.test(className);
	      }) ||
	      classes.find(function (className) {
	        return /^(shopify-section|section|template)-/.test(className);
	      }) ||
	      ''
	    );
	  }

	  function getContentName(element) {
	    if (!element) return '';
	    var explicitName =
	      element.getAttribute('data-evo-content-name') ||
	      element.getAttribute('data-content-name') ||
	      element.getAttribute('aria-label') ||
	      '';
	    if (explicitName) return truncateParam(explicitName, 80);
	    var heading = element.querySelector('h1, h2, h3, [data-evo-heading], .title, .heading');
	    return truncateParam(heading ? heading.textContent : getStableClassName(element), 80);
	  }

	  function isTrackableContentElement(element) {
	    if (!element || !(element instanceof Element)) return false;
	    if (element.closest('header, footer, .header, .footer, .shopify-section-header, .shopify-section-footer')) return false;
	    if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
	    var rect = element.getBoundingClientRect();
	    if (rect.width < 120 || rect.height < 80) return false;
	    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
	    if (style && (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0)) return false;
	    return true;
	  }

	  function getElementOverlapRatio(outer, inner) {
	    if (!outer || !inner) return 0;
	    var outerRect = outer.getBoundingClientRect();
	    var innerRect = inner.getBoundingClientRect();
	    var overlapWidth = Math.max(0, Math.min(outerRect.right, innerRect.right) - Math.max(outerRect.left, innerRect.left));
	    var overlapHeight = Math.max(0, Math.min(outerRect.bottom, innerRect.bottom) - Math.max(outerRect.top, innerRect.top));
	    var innerArea = Math.max(1, innerRect.width * innerRect.height);
	    return (overlapWidth * overlapHeight) / innerArea;
	  }

	  function hasSimilarTrackedAncestor(candidate, trackedElements) {
	    var candidateName = getContentName(candidate);
	    return trackedElements.some(function (tracked) {
	      if (!tracked || !tracked.contains(candidate) || tracked === candidate) return false;
	      var trackedName = getContentName(tracked);
	      var sameName = candidateName && trackedName && candidateName.toLowerCase() === trackedName.toLowerCase();
	      var trackedRect = tracked.getBoundingClientRect();
	      var candidateRect = candidate.getBoundingClientRect();
	      var similarHeight = trackedRect.height > 0 && candidateRect.height / trackedRect.height > 0.7;
	      var highOverlap = getElementOverlapRatio(tracked, candidate) > 0.8 && similarHeight;
	      return sameName || highOverlap;
	    });
	  }

	  function getContentCandidates() {
	    var main = document.querySelector('main') || document.body;
	    if (!main) return [];
	    var selector = [
	      '[data-evo-content-track]',
	      'section',
	      '.shopify-section',
	      '[id^="shopify-section-"]',
	      '.evolova-section',
	      '.evo-hero',
	      '.evo-products',
	      '.evo-tech',
	      '.evo-compare',
	      '.evo-pornstar',
	      '.evo-cta',
	      '.evo-product',
	      '.collection',
	      '.main-page'
	    ].join(',');
	    var nodes = Array.prototype.slice.call(main.querySelectorAll(selector));
	    var unique = [];
	    nodes.forEach(function (node) {
	      if (!isTrackableContentElement(node)) return;
	      if (unique.some(function (existing) { return existing === node; })) return;
	      if (hasSimilarTrackedAncestor(node, unique)) return;
	      unique.push(node);
	    });
	    return unique.slice(0, 32);
	  }

	  function buildContentMeta(element, index) {
	    var stableClass = getStableClassName(element);
	    var explicitId =
	      element.getAttribute('data-evo-content-id') ||
	      element.getAttribute('data-section-id') ||
	      element.getAttribute('data-section-type') ||
	      stableClass ||
	      element.id ||
	      '';
	    var pageTemplate = getPageTemplate();
	    var contentId = pageTemplate + ':' + slugifyParam(explicitId, 'section') + ':' + (index + 1);
	    return {
	      content_id: contentId,
	      content_name: getContentName(element) || contentId,
	      content_type: getContentType(element),
	      content_index: index + 1,
	      page_template: pageTemplate,
	      product_handle: productHandleFromUrl(),
	      language: getLanguageCode()
	    };
	  }

	  function trackContentSectionView(element) {
	    if (!element || contentEngagementState.viewedList.length >= contentEngagementState.maxSectionViews) return;
	    var meta = element.__evoContentMeta;
	    if (!meta || contentEngagementState.viewedById[meta.content_id]) return;
	    contentEngagementState.viewedById[meta.content_id] = true;
	    contentEngagementState.viewedList.push(meta);
	    contentEngagementState.maxScrollDepth = Math.max(contentEngagementState.maxScrollDepth, getScrollDepth());
	    sendGtag('content_section_view', Object.assign({}, meta, {
	      scroll_depth: contentEngagementState.maxScrollDepth
	    }));
	  }

	  function updateScrollDepthCheckpoints() {
	    contentEngagementState.maxScrollDepth = Math.max(contentEngagementState.maxScrollDepth, getScrollDepth());
	    [25, 50, 75, 90].forEach(function (checkpoint) {
	      if (contentEngagementState.depthCheckpoints[checkpoint]) return;
	      if (contentEngagementState.maxScrollDepth < checkpoint) return;
	      contentEngagementState.depthCheckpoints[checkpoint] = true;
	      sendGtag('content_depth_checkpoint', {
	        depth_checkpoint: checkpoint,
	        max_scroll_depth: contentEngagementState.maxScrollDepth,
	        page_template: getPageTemplate(),
	        product_handle: productHandleFromUrl(),
	        language: getLanguageCode()
	      });
	    });
	  }

	  function scheduleScrollDepthCheck() {
	    if (contentEngagementState.scrollTicking) return;
	    contentEngagementState.scrollTicking = true;
	    window.requestAnimationFrame(function () {
	      contentEngagementState.scrollTicking = false;
	      updateScrollDepthCheckpoints();
	    });
	  }

	  function getRecentContentSummary(key) {
	    return contentEngagementState.viewedList
	      .slice(-3)
	      .map(function (item) {
	        return truncateParam(item[key], key === 'content_id' ? 64 : 48);
	      })
	      .filter(Boolean)
	      .join('|');
	  }

	  function sendContentExitSummary() {
	    if (contentEngagementState.exitSent) return;
	    contentEngagementState.exitSent = true;
	    updateScrollDepthCheckpoints();
	    var lastContent = contentEngagementState.viewedList[contentEngagementState.viewedList.length - 1] || {};
	    sendGtag('content_exit_summary', {
	      last_content_id: lastContent.content_id,
	      last_content_name: truncateParam(lastContent.content_name, 80),
	      last_content_type: lastContent.content_type,
	      recent_content_ids: getRecentContentSummary('content_id'),
	      recent_content_names: getRecentContentSummary('content_name'),
	      max_scroll_depth: contentEngagementState.maxScrollDepth,
	      viewed_content_count: contentEngagementState.viewedList.length,
	      active_time_ms: Math.max(0, Date.now() - contentEngagementState.startedAt),
	      page_template: getPageTemplate(),
	      product_handle: productHandleFromUrl(),
	      language: getLanguageCode(),
	      transport_type: 'beacon'
	    });
	  }

	  function scanVisibleContentFallback(candidates) {
	    candidates.forEach(function (element) {
	      if (contentEngagementState.viewedById[element.__evoContentMeta && element.__evoContentMeta.content_id]) return;
	      var rect = element.getBoundingClientRect();
	      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
	      var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
	      if (visibleHeight > Math.min(rect.height * 0.35, viewportHeight * 0.5)) trackContentSectionView(element);
	    });
	  }

	  function initContentEngagementTracking() {
	    if (contentEngagementState.initialized || !document.body) return;
	    contentEngagementState.initialized = true;
	    contentEngagementState.startedAt = Date.now();
	    var candidates = getContentCandidates();
	    candidates.forEach(function (element, index) {
	      element.__evoContentMeta = buildContentMeta(element, index);
	    });
	    updateScrollDepthCheckpoints();
	
	    if ('IntersectionObserver' in window) {
	      contentEngagementState.observer = new IntersectionObserver(
	        function (entries) {
	          entries.forEach(function (entry) {
	            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
	              trackContentSectionView(entry.target);
	            }
	          });
	        },
	        { threshold: [0.35, 0.6], rootMargin: '0px 0px -10% 0px' }
	      );
	      candidates.forEach(function (element) {
	        contentEngagementState.observer.observe(element);
	      });
	    } else {
	      scanVisibleContentFallback(candidates);
	      window.addEventListener('scroll', function () {
	        scanVisibleContentFallback(candidates);
	      }, { passive: true });
	    }
	
	    window.addEventListener('scroll', scheduleScrollDepthCheck, { passive: true });
	    window.addEventListener('pagehide', sendContentExitSummary, { once: true });
	    document.addEventListener('visibilitychange', function () {
	      if (document.visibilityState === 'hidden') sendContentExitSummary();
	    });
	    window.setTimeout(function () {
	      scanVisibleContentFallback(candidates);
	    }, 800);
	  }
	
	  function primeCartWhenRelevant() {
	    if (
	      document.querySelector('cart-drawer, cart-items-component, .cart__checkout-button, [name="checkout"]') ||
      document.body.classList.contains('template-cart')
    ) {
      fetchCart();
    }
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
      var target = eventTarget?.closest('button, a, input[type="submit"]');
      if (!target) return;
      var label = (target.textContent || target.value || target.getAttribute('aria-label') || '').trim();
      if (/add\s*to\s*cart/i.test(label) || target.classList.contains('add-to-cart-button')) {
	        var form = getFormForTarget(target);
	        if (!form || !/\/cart\/add/.test(form.action || '')) return;
	        if (isManagedProductForm(form)) return;
	        trackAddToCartClick(form, target, 'pointerdown');
	      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
	      var form = event.target;
	      if (!form || !/\/cart\/add/.test(form.action || '')) return;
	      if (isManagedProductForm(form)) return;
	      trackAddToCartClick(form, event.submitter || form.querySelector('[type="submit"]'), 'submit');
	    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
      var target = eventTarget?.closest('button, a, input[type="submit"]');
      if (!target) return;

      var label = (target.textContent || target.value || target.getAttribute('aria-label') || '').trim();
      var href = target.getAttribute('href') || '';
      var name = target.getAttribute('name') || '';

      if ((/checkout/i.test(label) || name === 'checkout' || /\/checkout/.test(href)) && !target.matches('[disabled], [aria-disabled="true"]')) {
        trackCheckoutHandoff({
          target: target,
          source: 'checkout_click',
          sourceArea: getSourceArea(target, null)
        });
      }

      var productLink = target.closest('a[href*="/products/"]');
      if (productLink) {
        var productUrl = productLink.getAttribute('href') || '';
        var handle = productHandleFromUrl(productUrl);
        var listName = getListName(productLink, null);
        var listId = getListId(productLink, null);
        var position = getCardPosition(productLink, null);
        var title = getDataValue(productLink, 'productTitle') || productLink.getAttribute('aria-label') || productLink.textContent || handle;
        var productId = getDataValue(productLink, 'productId');
        var key = 'select-item:' + handle + ':' + listId + ':' + (position || '');
        if (handle && !dedupe(key, 1500)) {
          sendGtag('select_item', {
            item_list_name: listName,
            item_list_id: listId,
            source_area: getSourceArea(productLink, null),
            product_id: productId,
            product_handle: handle,
            items: [
              {
                item_id: productId || handle,
                item_name: String(title || '').trim(),
                item_brand: 'Evolova',
                item_category: 'product',
                item_list_name: listName,
                item_list_id: listId,
                index: position
              }
            ]
          });
        }
      }
    },
    true
  );

  document.addEventListener('evolova:cart-add-click', function (event) {
    trackAddToCartClick(event.detail?.form || null, event.detail?.target || null, 'evolova_event', event.detail || {});
  });

  document.addEventListener('evolova:cart-add-success', function (event) {
    trackAddToCartSuccess(event.detail || {});
  });

  document.addEventListener('evolova:cart-add-error', function (event) {
    trackAddToCartError(event.detail || {});
  });

  document.addEventListener('evolova:checkout-handoff', function (event) {
    trackCheckoutHandoff(event.detail || {});
  });

  document.addEventListener('evolova:cart-drawer-open', function (event) {
    trackCartDrawerOpen(event.detail || {});
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event?.cartData) return;
      if (hasRecentExplicitCartAdd(event.productVariantId, event.sourceArea || 'product_form', event.actionId)) return;
      trackAddToCartSuccess({
        response: event.cartData,
        variantId: event.productVariantId,
        source: event.source || 'cart_update',
        sourceArea: event.sourceArea || 'product_form'
      });
    });

    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      trackAddToCartError({
        variantId: event?.productVariantId,
        response: event,
        reason: event?.message || event?.errors || 'cart_error',
        sourceArea: event?.sourceArea || 'product_form'
      });
    });

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      var target = event?.data?.target;
      if (!target) return;
      var optionName =
        target.name ||
        target.closest?.('fieldset')?.querySelector('legend')?.textContent ||
        target.closest?.('.product-form__input')?.querySelector('.form__label')?.textContent ||
        'option';
      pendingVariantSelection = {
        optionName: String(optionName).trim(),
        optionValue: String(target.value || '').trim(),
        sourceArea: getSourceArea(target, null),
        time: Date.now()
      };

      window.setTimeout(function () {
        if (!pendingVariantSelection || Date.now() - pendingVariantSelection.time > 1500) return;
        var pending = pendingVariantSelection;
        pendingVariantSelection = null;
        var form = target.closest('product-info')?.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        sendGtag('variant_select', {
          product_handle: productHandleFromUrl(),
          variant_id: String(getFormDataValue(form, 'id') || ''),
          option_name: pending.optionName,
          option_value: pending.optionValue,
          source_area: pending.sourceArea
        });
      }, 1200);
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      trackVariantSelectFromPending(event?.data?.variant);
    });
  }

	  if (document.readyState === 'loading') {
	    document.addEventListener('DOMContentLoaded', primeCartWhenRelevant, { once: true });
	    document.addEventListener('DOMContentLoaded', initContentEngagementTracking, { once: true });
	  } else {
	    primeCartWhenRelevant();
	    initContentEngagementTracking();
	  }
	})();
